import Projects from "./Projects";

const screens = [...Projects];

export default screens;
